function PlayReadyManager() {

    // ---------- Constants ---------- //
    var NEEDKEY_EVENT = "msneedkey",
        KEYMESSAGE_EVENT = "mskeymessage",
        KEYADDED_EVENT = "mskeyadded",
        KEYERROR_EVENT = "mskeyerror",
        KEY_SYSTEM = "com.microsoft.playready";

    // ---------- Private Fields ---------- //
    var _videoElement, _licenseData;

    // ---------- Private methods ---------- //

    /**
     * Event handler for msneedkey event
     * @param e - event data
     */
    function onNeedPlayReadyKey(e) {
        window.console && console.log("Received needkey message");

        if (!_videoElement.msKeys) {
            window.console && console.log("Creating a new MediaKeys(\"" + KEY_SYSTEM + "\")");
            try {
                _videoElement.msSetMediaKeys(new MSMediaKeys(KEY_SYSTEM));
            } catch (e) {
                throw "Unable to create MediaKeys(\"" + KEY_SYSTEM + "\"). Verify the components are installed and functional. Original error: " + e.message;
            }
        } else {
            return;
        }

        var customDataBytes = createCustomDataBytes();
        var session = _videoElement.msKeys.createSession("video/mp4", e.initData, customDataBytes);
        if (!session) {
            throw "Could not create key session";
        }
        
        session.addEventListener(KEYMESSAGE_EVENT, function (e) {
            window.console && console.log("Processing key message");
            var keyMessage = String.fromCharCode.apply(null, new Uint16Array(e.message.buffer));
            downloadPlayReadyKey(e.destinationURL, keyMessage, function (data) {
                session.update(data);
            });
        });

        session.addEventListener(KEYADDED_EVENT, function () {
            window.console && console.log("Key successfully added");
        });

        session.addEventListener(KEYERROR_EVENT, function () {
            throw "Unexpected 'keyerror' event from key session. Code: " + session.error.code + ", systemCode: " + session.error.systemCode;
        });
    };

    function downloadPlayReadyKey(url, keyMessage, callback) {
        window.console && console.log("Parsing key message XML");
        var keyMessageXML = new DOMParser().parseFromString(keyMessage, "application/xml");

        var challenge;
        if (keyMessageXML.getElementsByTagName("Challenge")[0]) {
            challenge = atob(keyMessageXML.getElementsByTagName("Challenge")[0].childNodes[0].nodeValue);
        } else {
            throw "Can not find <Challenge> in key message";
        }

        var headerNames = keyMessageXML.getElementsByTagName("name");
        var headerValues = keyMessageXML.getElementsByTagName("value");
        if (headerNames.length !== headerValues.length) {
            throw "Mismatched header <name>/<value> pair in key message";
        }

        var xhr = new XMLHttpRequest();
        xhr.open("POST", url);
        xhr.responseType = "arraybuffer";
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    callback(new Uint8Array(xhr.response));
                } else {
                    throw "XHR failed (" + url + "). Status: " + xhr.status + " (" + xhr.statusText + ")";
                }
            }
        };
        for (var i = 0; i < headerNames.length; i++) {
            xhr.setRequestHeader(headerNames[i].childNodes[0].nodeValue, headerValues[i].childNodes[0].nodeValue);
        }

        window.console && console.log("Loading PlayReady key from: " + url);
        xhr.send(challenge);
    };

    /**
     * Creates custom data in proper format for license request and returns its bytes
     * @returns {Uint8Array}
     */
    function createCustomDataBytes() {
        var customDataValue = '<CustomerToken>' + _licenseData.customerToken + '</CustomerToken>' +
                              '<DeviceToken>' + _licenseData.customerToken + '</DeviceToken>' +
                              '<ContentId>' + _licenseData.mediaId +  '</ContentId>';

        // modify customData to be wide char
        var custombytes = convertToWideCharBytes(customDataValue);

        // convert modified custom data back to string representation
        var customString = "";
        for (var j = 0; j < custombytes.length; ++j) {
            customString += String.fromCharCode(custombytes[j]);
        }

        // encode in base64
        customDataValue = window.btoa(customString);

        var cdmData = '<PlayReadyCDMData type="LicenseAcquisition">'+
                          '<LicenseAcquisition version="1.0" Proactive="false">'+
                            '<CustomData encoding="base64encoded">' + customDataValue + '</CustomData>'+
                          '</LicenseAcquisition>'+
                      '</PlayReadyCDMData>';

        var resultBytes = convertToWideCharBytes(cdmData);
        return new Uint8Array(resultBytes);
    }

    /**
     * Converts string data to byte array, adding one more byte after every byte (to make wide chars)
     * @param stringData - input data
     * @returns {Array} - resulting array of bytes
     */
    function convertToWideCharBytes(stringData) {
        // custom data to byte array
        var bytes = [];
        // modify cdmData to be wide char : encoded on 2 bytes
        for (i = 0; i < stringData.length; ++i)
        {
            var charCode = stringData.charCodeAt(i);
            bytes.push(charCode);
            bytes.push(0);
        }

        return bytes;
    }

    // ---------------------- PUBLIC METHODS ---------------------- //

    /**
     * Preparation before license acquisition
     * @param manifest
     * @param callback
     */
    this.prepare = function(manifest, callback) {
        callback();
    };

    /**
     * Obtains license for video
     * @param videoElement
     * @param licenseData - object that contains custom license data
     */
    this.getLicense = function(context) {
        _videoElement = context.videoElement;
        _videoElement.addEventListener(NEEDKEY_EVENT, onNeedPlayReadyKey, false);
        _licenseData = context.licenseData;
    };
}